export default {
  create: function (name, proto) {
    this[name] = function () {
      if (proto.hasOwnProperty('construct') && typeof proto.construct === 'function') {
        proto.construct.apply(this, arguments)
      }
    }
    for (var p in proto) {
      this[name].prototype[p] = proto[p]
    }
    return this[name]
  },
  extend: function (name, superclass, proto) {
    this[name] = function () {
      superclass.call(this, arguments)
      if (proto.hasOwnProperty('construct') && typeof proto.construct === 'function') {
        proto.construct.apply(this, arguments)
      }
    }
    this[name].prototype = Object.create(superclass.prototype)
    this[name].prototype.contructor = this[name]
    for (var p in proto) {
      this[name].prototype[p] = proto[p]
    }
    return this[name]
  }
}
